<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-sm-12">
				<router-link
					v-if="isSuper"
					:to="{ name: 'Dashboard Add Lesson' }"
					class="btn btn-primary"
					>{{ 'Create Lesson' | translate }}</router-link
				>
			</div>
		</div>
		<div class="row">
			<div
				v-for="(lesson, index) in lessons"
				:key="index"
				class="col-xl-3 col-md-4 col-sm-6 col-12 lesson-item"
			>
				<router-link
					:to="{ name: 'Dashboard Lesson', params: { id: lesson.id } }"
				>
					<div class="lesson">
						<h6>{{ 'Lesson' | translate }} {{ lesson.order }}</h6>
						{{ lesson.name }}
					</div>
				</router-link>
				<div
					v-if="isSuper"
					class="remove-lesson"
					@click="openModal(lesson.id, 'delete')"
				>
					<i class="fa fa-trash" aria-hidden="true" />
				</div>
			</div>
		</div>
		<ModalDelete
			@close="showModal = false"
			@deleteUser="deleteLesson"
			:show="showModal"
		/>
	</div>
</template>

<script>
import ModalDelete from '../Modal/Delete.vue'
export default {
	name: 'Lessons',
	data() {
		return {
			lessons: [],
			isSuper: this.$store.state.myProfile.role === 'super franchise',
			showModal: false,
		}
	},
	components: {
		ModalDelete,
	},
	methods: {
		deleteLesson() {
			this.axios({
				method: 'delete',
				url: `lessons/${this.$store.state.modalId[0]}`,
			}).then(response => {
				this.showModal = false
				this.updateList()
			})
		},
		openModal(id, type) {
			let profileArr = []
			profileArr.push(id)
			this.$store.commit('changeModalId', profileArr)
			this.showModal = true
		},
		updateList() {
			this.axios({
				method: 'get',
				url: 'lessons/',
			}).then(response => {
				let lang = this.$i18n.locale()
				if (lang === 'ua') {
					lang = 'uk'
				}
				response.data.forEach(lesson => {
					lesson.name = lesson[`name_${lang}`]
				})
				this.lessons = response.data
			})
		},
	},
	beforeMount() {
		this.updateList()
	},
}
</script>

<style media="screen">
.remove-lesson {
	position: absolute;
	right: 25px;
	cursor: pointer;
	top: 12px;
	color: #fff;
	opacity: 0;
	transition: 0.2s;
	z-index: 15;
}

.lesson-item:hover .remove-lesson {
	opacity: 1;
}

.lesson-item {
	position: relative;
}

.lesson {
	background: #354051;
	color: #fff;
	padding: 10px;
	margin-top: 10px;
	margin-bottom: 10px;
	border-radius: 5px;
}

.lesson a {
	color: white;
}

.lesson a:hover {
	text-decoration: none;
}

.lesson * {
	margin: 0;
}
</style>
